import type { JSX } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Ic } from './Icons';
import { cn } from '../lib/classnames';
import './BottomNav.css';

interface NavItem {
  path: string;
  label: string;
  icon: () => JSX.Element;
}

const NAV_ITEMS: readonly NavItem[] = [
  { path: '/', label: 'лента', icon: Ic.list },
  { path: '/map', label: 'карта', icon: Ic.globe },
  { path: '/analytics', label: 'аналитика', icon: Ic.chart },
  { path: '/logs', label: 'события', icon: Ic.terminal },
] as const;

/** Bottom tab-bar. ``active`` state via the current location; we use
 *  ``startsWith`` so nested routes like ``/job/42`` (Phase 3.3) still
 *  light up the "лента" tab. */
export function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="bottomnav">
      {NAV_ITEMS.map(({ path, label, icon: IconCmp }) => {
        const active = path === '/' ? pathname === '/' || pathname.startsWith('/job') : pathname.startsWith(path);
        return (
          <button
            key={path}
            className={cn('nav-item', active && 'active')}
            onClick={() => navigate(path)}
          >
            <span className="icon">
              <IconCmp />
            </span>
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
